export const isOnFunnelStartRoute = () => {
  const pathname = typeof window !== 'undefined' ? window?.location?.pathname : '';

  const segments = pathname?.split('/')?.filter(Boolean);

  if (segments?.length === 2 && segments?.[0] === 'flow') {
    return true;
  }

  return false;
};
